/* Transient messages, stacked under the top bar. */

.toasts {
  position: absolute;
  top: calc(70px + var(--safe-t));
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
  z-index: 20;
}

.toast {
  pointer-events: none;
  max-width: min(440px, 88vw);
  padding: 10px 18px;
  border-radius: 999px;
  font-size: 13.5px;
  font-weight: 560;
  letter-spacing: -0.01em;
  color: var(--ink);
  background: var(--glass-strong);
  -webkit-backdrop-filter: var(--blur-lite);
  backdrop-filter: var(--blur-lite);
  border: 0.5px solid var(--glass-edge);
  box-shadow: var(--shadow-2);
  animation: toast-in 0.5s var(--ease) both;
  text-align: center;
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(-14px) scale(0.94);
  }
}
